const BREAK_POINTS = {
  MOBILE: 768,
  TABLET: 1024,
  // DESKTOP: 1280,
};

export default BREAK_POINTS;
